import ResponsiveImage from "components/ui/ResponsiveImage/ResponsiveImage";

function CenterSlide({ content }) {
  return (
    <div className={ 'slide-big-image' }>
      <ResponsiveImage value={ content }/>
    </div>
  );
}

export default CenterSlide;
